module.exports = __webpack_public_path__ + "img/01_uk.14e68cf7.svg";